import React from "react";
import { CommunityForumTab, ChallengesTab } from "@/components/sprintc/SprintCComponents";

const fontStack = { fontFamily: "'IBM Plex Sans', system-ui, sans-serif" };
const displayStack = { fontFamily: "'Outfit', system-ui, sans-serif" };

export function CommunityPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen pb-20" style={fontStack}>
      <section className="border-b border-white/5 py-10 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FF0066]/15 border border-[#FF0066]/30 text-[#FF0066] text-xs uppercase tracking-wider font-semibold">💬 Community</div>
          <h1 className="mt-4 text-3xl md:text-5xl font-extrabold" style={displayStack}>Discussion Forum</h1>
          <p className="mt-3 text-white/70 max-w-2xl">Ask doubts, share wins, learn together. Cross-batch discussion across all CWK students.</p>
        </div>
      </section>
      <section className="py-8 px-4">
        <div className="max-w-6xl mx-auto"><CommunityForumTab /></div>
      </section>
    </div>
  );
}

export function ChallengesPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen pb-20" style={fontStack}>
      <section className="border-b border-white/5 py-10 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/15 border border-amber-400/30 text-amber-300 text-xs uppercase tracking-wider font-semibold">🔥 Daily Challenges</div>
          <h1 className="mt-4 text-3xl md:text-5xl font-extrabold" style={displayStack}>Earn points. Climb the leaderboard.</h1>
          <p className="mt-3 text-white/70 max-w-2xl">Solve daily mini-tasks set by mentors. Get approved → earn points → win prizes.</p>
        </div>
      </section>
      <section className="py-8 px-4">
        <div className="max-w-6xl mx-auto"><ChallengesTab /></div>
      </section>
    </div>
  );
}
